import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Fetches displayName for a set of client IDs.
 * Returns a map of clientId -> displayName (or clientId if not found).
 */
export function useClientDisplayNames(clientIds) {
    const [names, setNames] = useState({});

    useEffect(() => {
        const uniqueIds = [...new Set((clientIds || []).filter(Boolean))];
        if (uniqueIds.length === 0) {
            setNames({});
            return;
        }

        const db = firebase.firestore();
        const fetches = uniqueIds.map((id) =>
            db.collection('clients').doc(id).get()
        );

        Promise.all(fetches).then((snapshots) => {
            const map = {};
            snapshots.forEach((snap, i) => {
                const id = uniqueIds[i];
                const data = snap.exists ? snap.data() : null;
                map[id] = data?.displayName || data?.profileDisplayName || id;
            });
            setNames(map);
        }).catch((err) => {
            console.error('useClientDisplayNames error:', err);
            setNames({});
        });
    }, [clientIds?.join(',')]);

    return names;
}
